export default {
  base: {
    maxWidth: ['100vw', 350, 605],
    mx: [20, 0, 0],
    backgroundColor: 'grey-100',
    display: 'flex',
    justifyContent: 'center',
    px: 7,
    py: 5,
    color: 'grey-0',
    fontFamily: 'base',
    fontSize: [12, null, 16],
    lineHeight: 1.5,
    fontWeight: 400,
    variant: 'spark.base.wrapper'
  },
  arrow: {
    base: {
      visibility: 'hidden',
      height: 12,
      width: 12,
      bottom: -6,
      position: 'absolute',
      backgroundColor: 'inherit',
      ':before': {
        position: 'absolute',
        content: '""',
        height: 12,
        width: 12,
        transform: 'rotate(45deg)',
        transformOrigin: 'center',
        backgroundColor: 'inherit',
        visibility: 'visible'
      }
    },
    variants: {
      top: {
        variant: 'spark.element.tooltip.arrow.base',
        top: -6
      },
      right: {
        variant: 'spark.element.tooltip.arrow.base',
        right: -6
      },
      bottom: {
        variant: 'spark.element.tooltip.arrow.base'
      },
      left: {
        variant: 'spark.element.tooltip.arrow.base',
        left: -6
      }
    }
  }
};